"use strict";
exports.__esModule = true;
exports.GdcScheduledMail = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @public
 */
var GdcScheduledMail;
(function (GdcScheduledMail) {
    function isKpiDashboardAttachment(obj) {
        return !isEmpty_1["default"](obj) && !!obj.kpiDashboardAttachment;
    }
    GdcScheduledMail.isKpiDashboardAttachment = isKpiDashboardAttachment;
})(GdcScheduledMail = exports.GdcScheduledMail || (exports.GdcScheduledMail = {}));
//# sourceMappingURL=GdcScheduledMail.js.map